<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card id="customerListcard" :loading="loading">
          <v-data-table
            :headers="headers"
            :items="roboterList"
            :search="search"
            :itemsPerPage="-1"
            multi-sort
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Roboter suchen"
                class="pa-4"
                :outlined="true"
                :filled="true"
                :clearable="true"
                background-color="#e8eff7"
              ></v-text-field>
            </template>

            <template slot="item.active" slot-scope="{ item }">
              <v-chip small :color="item.active ? 'success' : 'error'">{{
                item.active ? "Aktiv" : "Inaktiv"
              }}</v-chip>
            </template>

            <template slot="item.ownerCustomer" slot-scope="{ item }">
              {{ getCustomerName(item.ownerCustomer) }}
            </template>

            <template slot="item.actions" slot-scope="{ item }">
              <v-icon
                small
                class="mr-2"
                v-print="printObj"
                @click="printCodes(item)"
                >mdi-printer</v-icon
              >

              <v-icon small class="mr-2" @click="editItem(item)"
                >mdi-pencil</v-icon
              >

              <v-icon
                v-if="!isLoggedInUser(item)"
                small
                class="mr-2"
                @click="askDelete(item)"
                >mdi-delete</v-icon
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dlgDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Roboter löschen?</v-card-title>
        <v-card-text>
          Soll der Roboter
          <strong>{{ deleteItem.name }}</strong> wirklich gelöscht werden?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" outlined text @click="dlgDelete = false"
            >Abbrechen</v-btn
          >
          <v-btn dark color="red darken-1" @click="deleteRoboter">
            <v-icon>mdi-delete</v-icon>Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container
      v-if="printCodeItem"
      class="d-none d-print-block"
      id="printCodes"
    >
      <v-row>
        <v-col>
          <h2>Roboter Standort: {{ printCodeItem.standort }}</h2>
          <p>Roboter ID: {{ printCodeItem._id }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="4"
          v-for="(code, index) in printCodeItem.serviceCodes"
          :key="index"
        >
          <div>{{ code.name }}</div>
          <div><img :src="code.qrCode" width="150px" /></div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "RobotList",
  data: () => ({
    loading: false,
    search: "",
    dlgDelete: false,
    deleteItem: false,
    printObj: {
      id: "printCodes",
      popTitle: "Service Codes"
    },
    printCodeItem: null,

    headers: [
      { text: "Status", value: "active", width: "100px" },
      { text: "Name", value: "name", width: "150px" },
      { text: "Standort", value: "standort", width: "150px" },
      { text: "Eigentümer", value: "ownerCustomer" },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "110px",
        align: "right"
      }
    ]
  }),
  components: {},
  methods: {
    isLoggedInUser(item) {
      const user = this.$store.getters["user/getUser"];
      if (user._id === item._id) {
        return true;
      }
      return false;
    },
    userRole(item) {
      if (item.role == "superuser") return "Superuser";
      else if (item.role == "manager") return "System Admin";
      else if (item.role == "customer-admin") return "Kunden Admin";
      else if (item.role == "customer") return "Kunden Benutzer";
      else return item.role;
    },
    askDelete(item) {
      this.dlgDelete = true;
      this.deleteItem = item;
    },

    editItem(item) {
      this.$router.push({ name: "robots-edit", params: { id: item._id } });
    },
    getCustomerName(customerId) {
      if (customerId == "system") {
        return customerId;
      }

      const customer = this.$store.getters["customer/getCustomerList"].find(
        item => item._id === customerId
      );
      if (!customer) {
        return "Unknown Customer";
      }

      return (
        customer.name +
        " / " +
        customer.adresse +
        ", " +
        customer.plz +
        " " +
        customer.ort
      );
    },

    printCodes(item) {
      this.printCodeItem = item;
    },

    deleteRoboter() {
      this.dlgDelete = false;
      this.$store
        .dispatch("roboter/deleteRoboter", this.deleteItem._id)
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "info",
            title: "Roboter gelöscht",
            text: "Roboter " + this.deleteItem.name + " wurde gelöscht"
          });
        })
        .catch(error => {
          console.log(error);
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Löschen fehlgeschlagen",
            text:
              "Roboter " +
              this.deleteItem.name +
              " konnte nicht gelöscht werden."
          });
        });
    }
  },

  computed: {
    roboterList() {
      return this.$store.getters["roboter/getRoboterList"];
    }
  },

  created() {
    this.loading = true;
    this.$store
      .dispatch("roboter/fetchRoboterList")
      .then(() => {
        return this.$store.dispatch("customer/fetchCustomerList");
      })
      .then(() => {})
      .catch(error => {
        if (error.response.status != 401) {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message
          });
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style scoped>
#Customerlistcard {
  margin: 20px;
}
</style>
